/* eslint-disable import/prefer-default-export */
import handlebars from 'handlebars';

export function parseTemplate(template: string, variables: any) {
  // Parse the template using handlebars, leave the variables as unparsed
  const compiledTemplate = handlebars.compile(template);
  const parsedTemplate = compiledTemplate(variables);
  // Return the parsed template
  return parsedTemplate;
}
